import hljs from 'highlight.js';
import 'highlight.js/styles/base16/classic-light.css';
export function showCode() {
    document.addEventListener('DOMContentLoaded', (event) => {
        document.querySelectorAll('pre code').forEach((el) => {
            hljs.highlightElement(el);
        });
    });
}